import React from 'react';

const MessageBubble = ({ message }) => {
  const isUser = message.sender === 'user';
  const bubbleType = isUser ? 'user' : 'ai';

  return (
    <div className={`message-bubble-container ${bubbleType}`}>
      {!isUser && message.personaAvatarUrl && (
        <img
          src={message.personaAvatarUrl}
          alt={message.personaName}
          className="message-bubble-avatar"
        />
      )}
      <div className={`message-bubble-content ${bubbleType}`}>
        <p>{message.text}</p>
      </div>
    </div>
  );
};

export default MessageBubble;
